/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllAuthProvider = param => {
    return axiosInstance.post(`/api/gcadmin/v1/auth-provider/getAll`,param).then(res => res.data)
}
const createAuthProvider = (authProvider) => {
    return axiosInstance.post(`/api/gcadmin/v1/auth-provider/create`,authProvider).then(res => res.data)
}
const editAuthProvider = (authProvider) => {
    return axiosInstance.post(`/api/gcadmin/v1/auth-provider/update`,authProvider).then(res => res.data)
}

const getAuthProviderHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/auth-provider/get-history`,param).then(res => res.data)
}
export {
    getAllAuthProvider,
    createAuthProvider,
    editAuthProvider,
    getAuthProviderHistory
}
